<html>
<head>
  <style>
    * {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    body {
      padding: 0;
      margin: 0;
    }

    .gps-top-menu {
        visibility: hidden !important;
        display: none;
    }

    #unauthorized {
      position: relative;
      height: calc(100vh - 110px);

    }

    #unauthorized .unauthorized {
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }

    .unauthorized {
      max-width: 520px;
      width: 100%;
      line-height: 1.4;
      text-align: center;
    }

    .unauthorized .unauthorized-403 {
      position: relative;
      height: 200px;
      margin: 0px auto 20px;
      z-index: -1;
    }

    .unauthorized .unauthorized-403 h1 {
      font-family: Arial;
      font-size: 118px;
      font-weight: 200;
      margin: 0px;
      color: #211b191a;
      text-transform: uppercase;
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }

    .unauthorized .unauthorized-403 h2 {
      font-family: 'Montserrat', sans-serif;
      font-size: 28px;
      font-weight: 400;
      text-transform: uppercase;
      color: #211b19;
      background: transparent;
      padding: 10px 5px;
      margin: auto;
      display: inline-block;
      position: absolute;
      bottom: 50px;
      left: 0;
      right: 0;
    }

    .unauthorized a {
      font-family: 'Montserrat', sans-serif;
      display: inline-block;
      font-weight: 700;
      text-decoration: none;
      color: #fff;
      text-transform: uppercase;
      padding: 13px 23px;
      background: #ffc641;
      font-size: 18px;
      -webkit-transition: 0.2s all;
      transition: 0.2s all;
    }

    .unauthorized a:hover {
      color: #fff;
      background: #72aeb6;
    }

    @media only screen and (max-width: 767px) {
      .unauthorized .unauthorized-403 h1 {
        font-size: 74px;
      }
    }

    @media only screen and (max-width: 480px) {
      .unauthorized .unauthorized-403 {
        height: 74px;
        margin: 0px auto 10px;
      }

      .unauthorized .unauthorized-403 h1 {
        font-size: 43px;
      }

      .unauthorized .unauthorized-403 h2 {
        font-size: 16px;
      }

      .unauthorized a {
        padding: 7px 15px;
        font-size: 14px;
      }
    }
  </style>
</head>

<body>
  <div id="unauthorized">
    <div class="unauthorized">
      <div class="unauthorized-403">
        <h1>Authorized Error</h1>
        <h2>Not authorized, please contact admin</h2>
      </div>
    </div>
  </div>
</body>